import {
  Children,
  cloneElement,
  isValidElement,
  type ReactElement,
  type ReactNode,
} from "react";
import ToolboxSection from "./components/ToolboxSection/ToolboxSection";
import type { ToolboxSectionProps } from "./Toolbox.types";

/**
 * Filters React children to only include valid ToolboxSection components with icons.
 * Ensures each child has a unique 'value' prop by preserving existing values
 * or auto-assigning sequential string values (starting from 0) when missing.
 * The `value` prop is required for the Toolbox to know which section is currently selected.
 */
export const getValidChildren = (
  children: ReactNode
): ReactElement<ToolboxSectionProps>[] => {
  let index = 0;
  return Children.toArray(children)
    .filter((child) => {
      if (!isValidElement(child) || child.type !== ToolboxSection) return false;
      const typedChild = child as ReactElement<ToolboxSectionProps>;
      return !!typedChild.props.icon;
    })
    .map((child) => {
      const element = child as ReactElement<ToolboxSectionProps>;

      return cloneElement(element, {
        value: element.props.value || String(index++),
      });
    }) as ReactElement<ToolboxSectionProps>[];
};
